import React from 'react'
import {Box, Typography} from '@mui/material'

interface PlaceholderPageProps {
  title?: string
}

export default function PlaceholderPage({title: _title}: PlaceholderPageProps): JSX.Element {
  return (
    <Box>
      <Box sx={{py: 8, textAlign: 'center'}}>
        <Typography variant='body1' color='text.secondary'>
          {'Questa sezione sarà disponibile a breve.'}
        </Typography>
      </Box>
    </Box>
  )
}
